// src/services/convocatoriaService.js
import { getAuthHeader } from "./authService";

/** Base URL del backend */
const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/convocatorias`;

/* ========== Helpers ========== */
const toJson = (res) => res.json().catch(() => ({}));

const ensureOk = (res, data) => {
  if (!res.ok) {
    const msg =
      data?.message ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
};

/**
 * GET - Obtener todas las convocatorias de un evento específico
 * Endpoint: GET /api/convocatorias/:eventoId
 * @param {string} eventoId - ID del evento
 * @returns {Promise<Array>} Lista de convocatorias del evento
 */
export async function getConvocatoriasByEvento(eventoId) {
  if (!eventoId) {
    throw new Error("El ID del evento es requerido");
  }

  const res = await fetch(`${BASE_URL}/${eventoId}`, {
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? [];
}
